module.exports = __webpack_public_path__ + "static/media/Isiavwe.ebb0c704.jpg";